"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrderType = void 0;
var WorkOrderType;
(function (WorkOrderType) {
    WorkOrderType["NPI"] = "npi";
    WorkOrderType["PRODUCTION"] = "production";
    WorkOrderType["REWORK"] = "rework";
    WorkOrderType["RMA"] = "rma";
})(WorkOrderType = exports.WorkOrderType || (exports.WorkOrderType = {}));
//# sourceMappingURL=work-order-type.enum.js.map